import { ArrayParam, NumberParam, NumericArrayParam, StringParam, withDefault } from 'use-query-params';

import { dashboardConstants } from '.';

export const queryKeys = {
  WIDGETS: 'WIDGETS',
  WIDGET: 'WIDGET',
  DASHBOARD: 'DASHBOARD',
  SHARE: 'SHARE',
  SHARED_USERS: 'SHARED_USERS',
  EMPLOYEES_WITH_OBJ: 'employees_with_OBJ',
  PIPES_WITH_OBJ: 'PIPES_WITH_OBJ'
};

export const endPoints = {
  WIDGETS: '/v1/dashboard/widget',
  DASHBOARD: '/v1/dashboard',
  DASHBOARD_UPDATE: '/v1/dashboard/update',
  WIDGET_UPDATE: '/v1/dashboard/widget/update',
  SHARE: '/v1/dashboard/share',
  SHARED_USERS: '/v1/dashboard/shared-users/'
};

export const leadInitialColumn = [
  { id: '1', column: 'name' },
  { id: '2', column: 'contactName' },
  { id: '3', column: 'createdDate' },
  { id: '4', column: 'fullName' },
  { id: '5', column: 'pipeStatusName' }
];

export const taskInitialColumn = [
  { id: '1', column: 'clientName' },
  { id: '2', column: 'date' },
  { id: '3', column: 'leadTaskType' },
  { id: '4', column: 'text' },
  { id: '5', column: 'state' },
  { id: '6', column: 'assignedBy' }
];

export const eventListInitialColumn = [
  { id: '1', column: 'name' },
  { id: '2', column: 'createdDate' },
  { id: '3', column: 'actionType' },
  { id: '4', column: 'previous' },
  { id: '5', column: 'current' },
  { id: '6', column: 'responsibleBy' }
];

export const contractInitialColumns = [
  {
    id: '1',
    column: 'number'
  },
  {
    id: '2',
    column: 'clientName'
  },
  {
    id: '3',
    column: 'createdDate'
  },
  {
    id: '4',
    column: 'pricePerArea'
  },
  {
    id: '5',
    column: 'amount'
  },
  {
    id: '6',
    column: 'flatNumber'
  },
  // {
  //   id: '7',
  //   column: 'flatFloor'
  // },
  // {
  //   id: '8',
  //   column: 'flatRooms'
  // },
  {
    id: '9',
    column: 'discountPercent'
  },
  {
    id: '10',
    column: 'status'
  },
  {
    id: '11',
    column: 'responsibleBy'
  },
  {
    id: '12',
    column: 'houseName'
  }
];

export const sizes: Record<
  string,
  {
    minW: number;
    minH: number;
    maxW: number;
    maxH: number;
  }
> = {
  NUMBER: {
    minW: 2,
    minH: 2,
    maxW: 4,
    maxH: 3
  },
  LIST: {
    minW: 5,
    minH: 4,
    maxW: 8,
    maxH: 4
  },
  PIE_CHART: {
    minW: 5,
    minH: 5,
    maxW: 7,
    maxH: 7
  },
  DEFAULT: {
    minW: 4,
    minH: 4,
    maxW: 7,
    maxH: 7
  }
};

export const allDashboardTableColumns: Record<string, Array<any>> = {
  task: dashboardConstants.taskInitialColumn,
  contract: dashboardConstants.contractInitialColumns,
  TASK: dashboardConstants.taskInitialColumn,
  'event-list': dashboardConstants.eventListInitialColumn,
  LOG: dashboardConstants.eventListInitialColumn,
  log: dashboardConstants.eventListInitialColumn,
  default: dashboardConstants.leadInitialColumn
};

export const defaultEventListParamsMap = {
  startDate: StringParam,
  finishDate: StringParam,
  objectType: StringParam,
  objectStartDate: StringParam,
  objectFinishDate: StringParam,
  responsibleByIds: NumericArrayParam,
  actionTypes: ArrayParam,
  current: StringParam,
  previous: StringParam,
  currentStatuses: ArrayParam,
  previousStatuses: ArrayParam,
  currentTags: ArrayParam,
  previousTags: ArrayParam,
  clientIds: NumericArrayParam,
  search: StringParam,
  fields: ArrayParam,
  page: withDefault(NumberParam, 1),
  size: withDefault(NumberParam, 20)
};

export const secondEventListParamsMap = Object.keys(defaultEventListParamsMap).reduce(
  (pre, cur) => ({
    ...pre,
    [`two${cur.charAt(0).toUpperCase() + cur.slice(1)}`]:
      defaultEventListParamsMap[cur as keyof typeof defaultEventListParamsMap]
  }),
  {} as {
    [K in keyof typeof defaultEventListParamsMap as `two${Capitalize<K>}`]: (typeof defaultEventListParamsMap)[K];
  }
);
